import type { GeneratorComparisonSummary } from "encamp-shared/src/facility/generatorComparisonSummary";

import { Typography } from "@mui/material";
import { wasteGeneratorStatusToFullLabel } from "encamp-shared/src/waste";

export type ComparisonForDisplay = Pick<GeneratorComparisonSummary, "axis" | "direction"> &
  Partial<Omit<GeneratorComparisonSummary, "axis" | "direction">>;

export function priorityAxisLabel(comparison: ComparisonForDisplay): string {
  return comparison.axis === "STATE" ? "State" : "Federal";
}

export function priorityReportedLabel(comparison: ComparisonForDisplay): string {
  return comparison.reportedStatus
    ? wasteGeneratorStatusToFullLabel(comparison.reportedStatus)
    : "None reported";
}

export function priorityCalculatedLabel(comparison: ComparisonForDisplay): string {
  return comparison.calculatedStatus
    ? wasteGeneratorStatusToFullLabel(comparison.calculatedStatus)
    : "None calculated";
}

export function PriorityComparisonSummary({
  comparison,
}: {
  comparison?: ComparisonForDisplay | null;
}) {
  if (!comparison) return null;
  return (
    <Typography variant="body2">
      Priority: {priorityAxisLabel(comparison)} {priorityReportedLabel(comparison)} →{" "}
      {priorityCalculatedLabel(comparison)}
      {" · "}
      {comparisonDuration(comparison)}
      {comparison.earliestMismatch && comparison.latestMismatch && (
        <>
          {" "}
          · {comparison.earliestMismatch} – {comparison.latestMismatch}
        </>
      )}
    </Typography>
  );
}

function comparisonDuration(comparison: ComparisonForDisplay): string {
  if (
    comparison.sustainedMonths == null ||
    comparison.mismatchMonths == null ||
    comparison.spanMonths == null
  ) {
    return "Duration unavailable for this comparison";
  }
  return `${comparison.sustainedMonths} consecutive months · ${comparison.mismatchMonths} mismatch months · ${comparison.spanMonths} month span`;
}
